import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import $ from 'jquery';
// material UI

import * as CONSTANTS from '../constants';
import * as CONFIG from '../config';
import * as UTILS from '../utils/utilFunctions';
import TEXT from '../text';

import NotificationList from '../notifications/NotificationList';
import NotificationsSenatorV2 from '../notifications/NotificationsSenatorV2';
import ConfirmationModal from '../generic_components/ConfirmationModal';

class NotificationPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      deleteNotifications: false
    };
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  componentDidMount() {
    document.title = `Benachrichtigungen - ${UTILS.getTitle()}`;

    this.loadNotifications();
  }

  handleOpenDeleteNotificationsModal = () => {
    this.setState({ deleteNotifications: true });
  };

  handleMarkNotification = () => {
    const url = CONSTANTS.markNotificationsAsReadURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');

    const data = {
      notificationIds: this.state.notifications.map(notification => notification.id)
    };

    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'x-auth': tokenFromLocalStorage
      },
      data: JSON.stringify(data),
      timeout: CONFIG.ajaxTimeout
    })
      .done((responseBody, status) => {
        console.log('API /markNotificationsAsRead response status: ', status);
        this.loadNotifications();
        this.props.handleSnackbarOpen('Benachrichtigungen wurden als gelesen markiert.');
      })
      .fail(err => {
        this.errorHandling(err, url);
      });
  };

  handleCloseDeleteNotificationsModal = () => {
    this.setState({ deleteNotifications: false });
  };

  handleDeleteAllNotificationsAPICall = () => {
    const url = CONSTANTS.deleteAllUserNotificationsURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'x-auth': tokenFromLocalStorage
      },
      timeout: CONFIG.ajaxTimeout
    })
      .done((responseBody, status) => {
        console.log('API /deleteAllUserNotifications response status: ', status);
        this.setState({ notifications: [] });
        this.handleCloseDeleteNotificationsModal();
        this.props.handleSnackbarOpen('Alle Benachrichtigungen wurden gelöscht.');
      })
      .fail(err => {
        this.errorHandling(err, url);
      });
  };

  renderDeleteNotificationsPopUp() {
    return (
      this.state.deleteNotifications && (
        <ConfirmationModal
          key="confirmation-delete-notifications"
          handleClose={this.handleCloseDeleteNotificationsModal}
          open={this.state.deleteNotifications}
          buttonPrimaryAction={this.handleDeleteAllNotificationsAPICall}
          headlineText={TEXT.notificationPage.confirmationModal.headline}
          descriptionText={TEXT.notificationPage.confirmationModal.description}
        />
      )
    );
  }

  loadNotifications = () => {
    const url = CONSTANTS.getAllNotificationsOfUserURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'x-auth': tokenFromLocalStorage
      },
      timeout: CONFIG.ajaxTimeout
    })
      .done((responseBody, status) => {
        // console.log('API register response body: ', responseBody);
        console.log('API /notifications response status: ', status);
        this.setState({ notifications: responseBody });
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });
      })
      .fail(err => {
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });

        this.errorHandling(err, url);
      });
  };

  test() {
    this.setState();
  }

  render() {
    return (
      <div className="container h-100-minusAppBar" key="maincontainer">
        <div className="row justify-content-center align-items-center h-100">
          <div className="col-12 pt-3">
            {CONSTANTS.isSenator || CONSTANTS.isPersonalTotal ? (
              <>
                {this.renderDeleteNotificationsPopUp()}
                <NotificationsSenatorV2
                  notifications={this.state.notifications}
                  deleteNotifications={this.handleOpenDeleteNotificationsModal}
                  markNotification={this.handleMarkNotification}
                  refreshNotifications={this.loadNotifications}
                />
              </>
            ) : (
              <NotificationList
                timeSeparation
                handleSnackbarOpen={this.props.handleSnackbarOpen}
                notifications={this.state.notifications}
                onIsReadButtonClick={this.loadNotifications}
                onDeleteButtonClick={this.loadNotifications}
                onRowClick={this.props.liftUpStateToApp}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
NotificationPage.defaultProps = {};
NotificationPage.propTypes = {
  handleSnackbarOpen: PropTypes.func.isRequired,
  liftUpStateToApp: PropTypes.func.isRequired
};
export default NotificationPage;
